import { checkValidData } from "components/Formatter";
import { dayJsDateFormatter } from "utils";
import { ext } from "helpers";
import { Container } from "react-bootstrap";
import ModalComponent from "../Modal/Index";
import { AudioElement, ImageElement, VideoElement } from "..";

function AlbumModal({ handleCloseModal, setData, data, showModal }) {
  return (
    <ModalComponent
      size="md"
      show={showModal}
      onHandleCancel={() => {
        handleCloseModal();
        setData({});
      }}
      extraClassName="imageSlider imageSlider-img imageSlider-audio"
      backdropClassName="sliderBack"
      closeVariant="white"
    >
      <Container>
        <div className="slider_content slider">
          <h2 className="text-break"> {checkValidData(data?.title)}</h2>
          <h3> {dayJsDateFormatter(data?.date, "MMM DD, YYYY")}</h3>
          <p className="mb-md-4 mb-3 text-break">
            {checkValidData(data?.description)}
          </p>
          {ext?.[data?.albumImageUrl?.split(".")?.pop()] === "video" && (
            <VideoElement
              previewSource={data?.albumImageUrl}
              extraClassName="h-auto z-1 position-relative timeLine-video"
              alt="timeline-img"
              autoPlay
            />
          )}
          {ext?.[data?.albumImageUrl?.split(".")?.pop()] === "image" && (
            <ImageElement
              previewSource={data?.albumImageUrl}
              className="position-relative w-100"
              alt="timeline-img"
            />
          )}
          {ext?.[data?.albumImageUrl?.split(".")?.pop()] === "audio" && (
            <AudioElement
              previewSource={data?.albumImageUrl}
              alt="timeline-img"
            />
          )}
        </div>
      </Container>
    </ModalComponent>
  );
}

export default AlbumModal;
